import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row g-6 g-xl-9" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body d-flex flex-md-center align-items-center p-4" }
const _hoisted_4 = { class: "symbol symbol-65px symbol-circle me-4" }
const _hoisted_5 = {
  key: 0,
  class: "symbol-label fs-2x fw-bold text-primary bg-light-primary"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "bg-success position-absolute border border-4 border-white h-15px w-15px rounded-circle translate-middle start-100 top-100 ms-n3 mt-n3" }, null, -1)
const _hoisted_8 = { class: "d-flex flex-column mt-5" }
const _hoisted_9 = { class: "fs-4 text-gray-900 fw-bolder mb-0" }
const _hoisted_10 = { class: "fs-7 text-gray-700 fw-bolder mb-0" }
const _hoisted_11 = { class: "fw-bold text-gray-800 mb-6" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex flex-center flex-wrap"
}
const _hoisted_13 = { class: "border border-gray-400 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3" }
const _hoisted_14 = { class: "fs-6 fw-bolder text-gray-800" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-gray-500" }, "Role", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePeople, (person) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-12 col-md-4",
        key: person.accountId
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (!person.avatar)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(person.fullName[0]), 1))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: person.avatar,
                    alt: "image"
                  }, null, 8, _hoisted_6)),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(person.fullName), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(person.pronouns), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(person.title), 1),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.getRole(person.role).name), 1),
                      _hoisted_15
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    }), 128))
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}